"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    { name: '韩国', value: 'KR' },
    { name: '美国', value: 'US' },
    { name: '日本', value: 'JP' },
    { name: '中国', value: 'CN' },
    { name: '台湾', value: 'TW' },
    { name: '泰国', value: 'TH' },
    { name: '加纳', value: 'GH' },
    { name: '印度尼西亚', value: 'ID' },
    { name: '越南', value: 'VN' },
    { name: '新加坡', value: 'SG' },
    { name: '马来西亚', value: 'MY' },
    { name: '加拿大', value: 'CA' },
    { name: '菲律宾', value: 'PH' },
    { name: '香港', value: 'HK' },
    { name: '美属维尔京群岛', value: 'VI' },
    { name: '澳大利亚', value: 'AU' },
    { name: '法国', value: 'FR' },
    { name: '德国', value: 'DE' },
    { name: '巴西', value: 'BR' },
    { name: '英国', value: 'GB' },
    { name: '俄罗斯', value: 'RU' },
    { name: '墨西哥', value: 'MX' },
    { name: '新西兰', value: 'NZ' },
    { name: '印度', value: 'IN' },
    { name: '瑞典', value: 'SE' },
    { name: '秘鲁', value: 'PE' },
    { name: '西班牙', value: 'ES' },
    { name: '智利', value: 'CL' },
    { name: '缅甸', value: 'MM' },
    { name: '多哥', value: 'TG' },
    { name: '挪威', value: 'NO' },
    { name: '阿根廷', value: 'AR' },
    { name: '危地马拉', value: 'GT' },
    { name: '芬兰', value: 'FI' },
    { name: '葡萄牙', value: 'PT' },
    { name: '保加利亚', value: 'BG' },
    { name: '福克兰群岛（马尔维纳斯）', value: 'FK' },
    { name: '以色列', value: 'IL' },
    { name: '拉脱维亚', value: 'LV' },
    { name: '阿联酋', value: 'AE' },
    { name: '荷兰', value: 'NL' },
    { name: '安圭拉', value: 'AI' },
    { name: '洪都拉斯', value: 'HN' },
    { name: '哥伦比亚', value: 'CO' },
];
